import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth-context";
import { api } from "../lib/api";

export function Settings() {
  const { account, refresh } = useAuth();
  const [name, setName] = useState(account?.name ?? "");
  const [location, setLocation] = useState(account?.location ?? "");
  const [saved, setSaved] = useState(false);
  const [following, setFollowing] = useState<{ id: string; name: string; handle: string }[]>([]);

  useEffect(() => {
    api.get<{ following: any[] }>("/me/following").then((r) => setFollowing(r.following));
  }, []);

  async function save(e: React.FormEvent) {
    e.preventDefault();
    await api.patch("/me/profile", { name, location });
    await refresh();
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  async function unfollow(id: string) {
    await api.delete(`/me/follow/${id}`);
    setFollowing((f) => f.filter((p) => p.id !== id));
  }

  return (
    <main className="page" style={{ maxWidth: 640 }}>
      <h1 className="page-title" style={{ fontSize: 36, marginBottom: 30 }}>
        Settings
      </h1>

      <form onSubmit={save}>
        <div className="field" style={{ marginBottom: 16 }}>
          <label>Name</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="field" style={{ marginBottom: 16 }}>
          <label>Location</label>
          <input className="input" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="City, country" />
        </div>
        <div className="field" style={{ marginBottom: 16 }}>
          <label>Handle</label>
          <input className="input" value={account?.handle ?? ""} disabled />
        </div>
        <button className="btn btn-primary" type="submit">
          Save
        </button>
        {saved && (
          <span className="muted-strong" style={{ marginLeft: 12, fontSize: 13 }}>
            Saved.
          </span>
        )}
      </form>

      <hr className="hr" style={{ margin: "36px 0" }} />

      <h2 style={{ fontSize: 20, marginBottom: 16 }}>Following</h2>
      {following.length === 0 && <p className="muted">You're not following anyone yet — do that from a recipe page.</p>}
      {following.map((p) => (
        <div key={p.id} className="spread" style={{ padding: "10px 0", borderBottom: "1px solid var(--color-divider)" }}>
          <span>
            {p.name} <span className="muted-strong">@{p.handle}</span>
          </span>
          <button className="btn btn-ghost" onClick={() => unfollow(p.id)}>
            Unfollow
          </button>
        </div>
      ))}
    </main>
  );
}
